import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`What's next level for C++? I think it should be something help scaling the performance and robustness to industrial standard level...`}</p>
    <h1>{`Background`}</h1>
    <p>{`So this article just lists what I believe should be important for level 2 C++ programmers. Most of them are probably biased to game dev and are inspired a lot from either Boost, Folly, EASTL etc. Even though leaning to game dev, but I think most of cure for problem are commonly shared across similar problems in different field.`}</p>
    <h1>{`Language Tricks`}</h1>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`You know what: branching can be optimized! For game developer, every bit count, even probability. [`}{`[likely]`}{`] newly added to C++ std will help compiler generate better asm code to predict branching. Some library can do that before this C++ std.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ScopeGuard<Function or Lambda`}{`>`}{` : use destructor to guarantee cleanup in throwing environment and use function to avoid overhead (0 overhead actually).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Compile-Time calculation: Meta programming allows you to get Fib<100>() like a constant after compiled; also it enable you to check type Traits.h without any runtime cost.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Copyable Function: `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`replacement new: new(pointer) Class, note you need to free your pointer (responeding to the way it created) and call destructor.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`static_assert: check compile time values, template etc.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`cache friendly programming tricks: abusing hardware. this is like dark alchemy: `}<a parentName="p" {...{
            "href": "https://stackoverflow.com/questions/16699247/what-is-a-cache-friendly-code"
          }}>{`https://stackoverflow.com/questions/16699247/what-is-a-cache-friendly-code`}</a>{` Note you need to know your hardware and compiler well and use it for bottleneck's bottleneck. It's often not transferrable when moving to different devices...`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`noexcept can be helpful in case of moving etc.`}</p>
      </li>
    </ul>
    <h1>{`Memory Allocation`}</h1>
    <p>{`Arena Allocation. Common in game engine. Make memory allocation as raw as C. No destructor, only pointer moving! `}<a parentName="p" {...{
        "href": "https://developers.google.com/protocol-buffers/docs/reference/arenas"
      }}>{`Reference`}</a>{`: "New objects are allocated out of a large piece of preallocated memory called the arena. Objects can all be freed at once by discarding the entire arena, ideally without running destructors of any contained object (though an arena can still maintain a "destructor list" when required). This makes object allocation faster by reducing it to a simple pointer increment, and makes deallocation almost free. Arena allocation also provides greater cache efficiency: when messages are parsed, they are more likely to be allocated in continuous memory, which makes traversing messages more likely to hit hot cache lines."`}</p>
    <p>{`For game, one arena per levels; while for server, one arena for one request session. This idea also works for IO like serialization, basically save the overhead of default C++.`}</p>
    <h1>{`Rellocation`}</h1>
    <p>{`realloc is raw, rellocable is to deal with the constructor/destructor/memcpy issues.`}</p>
    <h1>{`String`}</h1>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`std::string`}</code>{` is simple but I've never seen a game engine in my life that use it 😆 (actually true for STL as well). I think game developer follows the `}<a parentName="p" {...{
        "href": "https://github.com/id-Software/DOOM-3/blob/master/neo/idlib/containers/StrPool.h"
      }}>{`string pool idea`}</a>{`. It's so called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`interned string`}</code>{`, a huge hash table of string to make sure every string only have one copy (also see `}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/interning-of-string/"
      }}>{`here`}</a>{`). It's efficient for game's string which doesn't really change much. Combined with some `}<a parentName="p" {...{
        "href": "https://en.cppreference.com/w/cpp/language/user_literal"
      }}>{`C++ tricks`}</a>{` you can basically treat any constant string in C++ as a HashID.`}</p>
    <p>{`For runtime, library like Folly chooses to handle string in more wild use cases with three strategies based on size of string. Small string in static stack memory. Large size string is lazily copied or somehow interned. Medium string is equivalent to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`std::string`}</code>{`.`}</p>
    <h1>{`Lock Free`}</h1>
    <p>{`You should always use lock free or non-blocking concurrency strategy. That means better stay away from mutex, semaphore etc. Why? cause you don't want to spend cycles on thread context management (put them sleep and signal them awake) and many bugs like dead lock. But how? Use atomicity. Careful design your datastructure and logic. For competing resource e.g. multiple writers, spin lock it and try CompareAndSwap (or waitandwrite). `}</p>
    <p>{`However, this is not Elixir. CompareAndSwap (CAS) fails is a usual things in high contention environment and if thread is trying to do heavy works for CAS, it'll be disaster to see failed threads repeating the heavy works due to CAS failure. Plus, the lock free`}</p>
    <h1>{`Future & Executor`}</h1>
    <p>{`Javascript is a good place to experience Future and Promise. It's able to chaining callback and help you manage worker thread easier.
`}<img parentName="p" {...{
        "src": "../images/blog/2022/image.png",
        "alt": "Xenoblade Shulk: We CAN change the future!"
      }}></img></p>
    <p>{`The way to make it efficient is based on implementation of threadpool. A typical one would be `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Folly::CPUThreadPoolExecutor`}</code>{`, where caller just create tasks in priority queue and workers in threadpool keeps polling the queue and execute the tasks.`}</p>
    <h1>{`STL`}</h1>
    <p>{`To be short, don't use it in game runtime. It's too general to be fast enough. Use the something from e.g. Folly.`}</p>
    <h1>{`Exception`}</h1>
    <p>{`Return by value and exception happens! `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`share_ptr`}</code>{` to rescue.`}</p>
    <h1>{`Intrusive vs Non-intrusive`}</h1>
    <p>{`Think about 2 different e.g. vector, one you store `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`vector<MyClass>`}</code>{` and another you store `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`vector<MyClass*>`}</code>{`. For latter one, you saved the cost of copy constructing elements by only copying pointers. Intrusive container works like this.
You basically inherit intrusive container node to create your object class or follows the interface. `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": ".cpp"
    }}><pre parentName="div" {...{
        "className": "language-.cpp"
      }}><code parentName="pre" {...{
          "className": "language-.cpp"
        }}>{`class MyClass: IntrusiveContainerNode<MyClass>
{
   // from parent: MyClass *next;
   // from parent: MyClass *previous;
   int value;
};`}</code></pre></div>
    <p><a parentName="p" {...{
        "href": "https://www.boost.org/doc/libs/1_35_0/doc/html/intrusive/intrusive_vs_nontrusive.html#id932296"
      }}>{`https://www.boost.org/doc/libs/1_35_0/doc/html/intrusive/intrusive_vs_nontrusive.html#id932296`}</a></p>
    {/* # 1 Hit Elden Ring */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      